import axios from 'src/app-axios';
import Constants from 'src/constants';

export const countries = {
  namespaced: true,
  state: {
    userCountries: [],
  },
  getters: {
    getCountries (state) {
      return state.userCountries;
    },
  },
  mutations: {
    setCountries (state, data) {
      state.userCountries = data;
    },
  },
  actions: {
    async fetchCountries ({ dispatch, commit }, payload) {
      const url = '/api/devices/country-codes';
      try {
        const documents = await axios.get(url);
        commit('setCountries', documents.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the documents.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
  },
};
